/* Dialog Text */
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import { Interact, Interacts } from "../../../api/models";

export interface EditInteractReportsDialogData {
  dialogTitle: string;
  isNew: boolean;
  interacts: Interacts[];
  interactReportId: number;
  interactId: number;
  name: string;
  description: string;
  powerBIPrefix: string;
  displayRank: number;
}

@Component({
  selector: "edit-interactive-report-dialog",
  styleUrls: ["edit-interactive-report-dialog.component.css"],
  templateUrl: "./edit-interactive-report-dialog.component.html",
})
export class EditInteractReportsDialogComponent {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<EditInteractReportsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditInteractReportsDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }
}

/* Calling Methods */
/*
  callEditInteractReports(params: EditInteractReportsDialogData) {
    var dialogRef = this.dialog.open(EditInteractReportsDialogComponent, {
      width: '500px',
      data: params
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
        //Do something here!
      }
    });
  }
*/
